import styled from 'styled-components';
import {
  SomaModal,
} from '@soma/react';
import { DialogHeader } from 'xpi-black-ui/Common/Dialog';

export const Modal = styled(SomaModal)`
  &::part(container) {
    position: relative;
    padding: 0px;
  }
  &::part(container) > .soma-modal-closearea {
    margin-bottom: 24px;
    float: right;
    padding: 7px;
    zoom: 1.5;
  }
`;

export const NotificationContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const BlackDialogHeader = styled(DialogHeader)`
  border-bottom: 0px;
  height: 60px;
  h1 {
    color: #1F1F1F !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Paragraph = styled.p`
  margin-bottom: 0.5rem !important;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: start;
`;

export const Text = styled.span`
  margin-bottom: 1rem;
`;
